<template>
    <section class="ion-item-group">
        <slot></slot>
    </section>
</template>
<script>
    export default {
        name: 'ion-item-group'
    }
</script>


// WEBPACK FOOTER //
// item.group.vue?07e3553f